module.exports = __webpack_public_path__ + "img/11.4e6cfa7b.jpg";